import { Children, type ReactNode, isValidElement } from "react";

const FUNNEL_STEP_DISPLAY_NAME = "Funnel.Step";

interface FunnelProps {
  step: string;
  children: ReactNode;
}

interface StepProps {
  name: string;
  children: ReactNode;
}

function FunnelStep({ children }: StepProps) {
  return <>{children}</>;
}
FunnelStep.displayName = FUNNEL_STEP_DISPLAY_NAME;

function isFunnelStep(child: React.ReactElement): child is React.ReactElement<StepProps> {
  const type = child.type;
  if (typeof type === "function" || typeof type === "object") {
    return (type as { displayName?: string }).displayName === FUNNEL_STEP_DISPLAY_NAME;
  }
  return false;
}

function FunnelRoot({ step, children }: FunnelProps) {
  const childArray = Children.toArray(children);

  for (const child of childArray) {
    if (isValidElement(child) && isFunnelStep(child) && child.props.name === step) {
      return child;
    }
  }

  return null;
}

export const Funnel = Object.assign(FunnelRoot, { Step: FunnelStep });
